export const COUNTRY = {
  GET: 'GET_COUNTRY',
  GET_SUCCESS: 'GET_COUNTRY_SUCCESS',
  GET_FAILURE: 'GET_COUNTRY_FAILURE',
}
